import type { WebSocketResponse, WebSocketDataChunk } from '~/modules/apps/contexts/type';
import type { ICampaignAnalytic } from '~/types/metric';

export enum AnalyticInterval {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  WEEK = 'WEEK',
  YEAR = 'YEAR',
}

export type WSAnalyticDataMetric = WebSocketDataChunk<ICampaignAnalytic[]>;
export type WSAnalyticResponse = WebSocketResponse<WSAnalyticDataMetric>;
